import { create } from 'zustand';

const useAuthStore = create((set) => ({
  // State
  isAuthed: false,
  isLoggedIn: false,
  isLoggingIn: false,
  salespersonId: null,
  salespersonNid: null,
  salespersonName: null,

  // Community access state (for non-kiosk mode)
  accessChecked: false,
  hasAccess: true, // Default to true, only set to false if check fails
  accessDeniedMessage: null,

  // Actions
  setIsAuthed: (isAuthed) => set({ isAuthed }),
  setIsLoggedIn: (isLoggedIn) => set({ isLoggedIn }),
  setIsLoggingIn: (isLoggingIn) => set({ isLoggingIn }),
  setSalespersonId: (salespersonId) => set({ salespersonId }),
  setSalespersonNid: (salespersonNid) => set({ salespersonNid }),
  setSalespersonName: (salespersonName) => set({ salespersonName }),

  // Access check actions
  setAccessChecked: (accessChecked) => set({ accessChecked }),
  setHasAccess: (hasAccess) => set({ hasAccess }),
  setAccessDeniedMessage: (accessDeniedMessage) => set({ accessDeniedMessage }),
  denyAccess: (message) => set({
    accessChecked: true,
    hasAccess: false,
    accessDeniedMessage: message,
  }),
  grantAccess: () => set({
    accessChecked: true,
    hasAccess: true,
    accessDeniedMessage: null,
  }),

  // Bulk updates
  loginSuccess: (data) => set({
    isLoggedIn: true,
    salespersonId: data.user_uuid,
    salespersonNid: data.user_nid,
    // salespersonName is fetched separately via API in App.js
    // Reset access state on new login
    accessChecked: false,
    hasAccess: true,
    accessDeniedMessage: null,
  }),
  logout: () => set({
    isLoggedIn: false,
    salespersonId: null,
    salespersonNid: null,
    salespersonName: null,
    // Reset access state on logout
    accessChecked: false,
    hasAccess: true,
    accessDeniedMessage: null,
  }),
}));

export default useAuthStore;
